import Table from 'react-bootstrap/Table';
import Papa from 'papaparse';
import React, { useState, useEffect } from 'react';
import FileInput from './FileInput';
import MSATable from './Table';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../Main.css'
//import '../tailwind.css';
import img1 from '../images/1.jpg';
const defaultValues = {}

function MSAType2() {
    let totalNoofColumns = 15;
    let totalNoofRows = 50;
    let inputHeaders = ['Bauteil', 'Prüfer', 'Messwert'];
    let inputData = [['Teil1', 'Andreas', 1.807], ['Teil2', 'Andreas', 1.629], ['Teil3', 'Andreas', 1.525], ['Teil4', 'Andreas', 1.736], ['Teil1', 'Anne', 1.564], ['Teil2', 'Anne', 1.417], ['Teil3', 'Anne', 1.576], ['Teil4', 'Anne', 1.463], ['Teil1', 'Michael', 1.569], ['Teil2', 'Michael', 1.588], ['Teil3', 'Michael', 1.247], ['Teil4', 'Michael', 1.361], ['Teil1', 'Andreas', 1.59], ['Teil2', 'Andreas', 1.558], ['Teil3', 'Andreas', 1.646], ['Teil4', 'Andreas', 1.576], ['Teil1', 'Anne', 1.481], ['Teil2', 'Anne', 1.821], ['Teil3', 'Anne', 1.578], ['Teil4', 'Anne', 1.648], ['Teil1', 'Michael', 1.382], ['Teil2', 'Michael', 1.509], ['Teil3', 'Michael', 1.286], ['Teil4', 'Michael', 1.538], ['Teil1', 'Andreas', 1.692], ['Teil2', 'Andreas', 1.641], ['Teil3', 'Andreas', 1.462], ['Teil4', 'Andreas', 1.71], ['Teil1', 'Anne', 1.642], ['Teil2', 'Anne', 1.608], ['Teil3', 'Anne', 1.598], ['Teil4', 'Anne', 1.492], ['Teil1', 'Michael', 1.614], ['Teil2', 'Michael', 1.596], ['Teil3', 'Michael', 1.601], ['Teil4', 'Michael', 1.438]]
    //let inputData = [['Teil1', 'Andreas', 1.807, 1.707], ['Teil2', 'Andreas', 1.629, 1.529], ['Teil3', 'Andreas', 1.525, 1.425], ['Teil4', 'Andreas', 1.736, 1.636], ['Teil1', 'Anne', 1.564, 1.464], ['Teil2', 'Anne', 1.417, 1.317], ['Teil3', 'Anne', 1.576, 1.476], ['Teil4', 'Anne', 1.463, 1.363], ['Teil1', 'Michael', 1.569, 1.469], ['Teil2', 'Michael', 1.588, 1.488], ['Teil3', 'Michael', 1.247, 1.147], ['Teil4', 'Michael', 1.361, 1.261], ['Teil1', 'Andreas', 1.59, 1.49], ['Teil2', 'Andreas', 1.558, 1.458], ['Teil3', 'Andreas', 1.646, 1.546], ['Teil4', 'Andreas', 1.576, 1.476], ['Teil1', 'Anne', 1.481, 1.381], ['Teil2', 'Anne', 1.821, 1.721], ['Teil3', 'Anne', 1.578, 1.478], ['Teil4', 'Anne', 1.648, 1.548], ['Teil1', 'Michael', 1.382, 1.282], ['Teil2', 'Michael', 1.509, 1.409], ['Teil3', 'Michael', 1.286, 1.186], ['Teil4', 'Michael', 1.538, 1.438], ['Teil1', 'Andreas', 1.692, 1.592], ['Teil2', 'Andreas', 1.641, 1.541], ['Teil3', 'Andreas', 1.462, 1.362], ['Teil4', 'Andreas', 1.71, 1.61], ['Teil1', 'Anne', 1.642, 1.542], ['Teil2', 'Anne', 1.608, 1.508], ['Teil3', 'Anne', 1.598, 1.498], ['Teil4', 'Anne', 1.492, 1.392], ['Teil1', 'Michael', 1.614, 1.514], ['Teil2', 'Michael', 1.596, 1.496], ['Teil3', 'Michael', 1.601, 1.501], ['Teil4', 'Michael', 1.438, 1.338]]

    let defaultHeaders = [""]
    let defaultData = []
    for (let i = 0; i < inputHeaders.length; i++) {
        defaultHeaders.push(inputHeaders[i]);
    }

    for (let i = defaultHeaders.length + 1; i <= totalNoofColumns + 1; i++) {
        defaultHeaders.push("")
    }

    for (let i = 0; i < inputData.length; i++) {
        let row = [i + 1];
        for (let j = 0; j < inputData[i].length; j++) {
            row.push(inputData[i][j]);
        }
        defaultData.push(row);
    }

    for (let i = defaultData.length - 1; i < totalNoofRows; i++) {
        let newRow = [i]
        for (let j = 0; j < totalNoofColumns; j++) {
            newRow.push("")
        }
        defaultData.push(newRow)
    }

    for (let i = 0; i < totalNoofRows; i++) {
        for (let j = defaultData[i].length; j <= totalNoofColumns; j++) {
            defaultData[i].push("");
        }
    }

    let emptyHeaders = []
    let emptyData = [];
    for (let i = 0; i <= totalNoofColumns; i++) {
        emptyHeaders.push("")
    }
    for (let i = 0; i < totalNoofRows; i++) {
        let row = [i + 1];
        for (let j = 0; j < totalNoofColumns; j++) {
            row.push("");
        }
        emptyData.push(row);
    }

    const [pyPlot, setPyPlot] = useState()
    //const [QQPlot, setQQPlot] = useState()
    const [csvData, setCsvData] = useState(defaultData);
    const [headers, setHeaders] = useState(defaultHeaders);
    const [variableNo, setVariableNo] = useState(3);
    const [groupBy, setGroupBy] = useState('Bauteil');
    const [linesBy, setLinesBy] = useState('Prüfer');
    const [anovaTable, setAnovaTable] = useState({ 'df': { 'C(Bauteil)': 0, 'C(Prüfer)': 0, 'C(Residual)': 0 }, 'sum_sq': { 'C(Bauteil)': 0, 'C(Prüfer)': 0, 'C(Residual)': 0 }, 'mean_sq': { 'C(Bauteil)': 0, 'C(Prüfer)': 0, 'C(Residual)': 0 }, 'F': { 'C(Bauteil)': 0, 'C(Prüfer)': 0, 'C(Residual)': 0 }, 'PR(>F)': { 'C(Bauteil)': 0, 'C(Prüfer)': 0, 'C(Residual)': 0 } });
    const [Table2, setTable2] = useState({
        "Variance (VarComp)": {
            "Part-to-part": 0.0006137811,
            "Opperator": 0.0050222957,
            "Repeat": 0.012062813,
            "PartOperator": 0,
            "Reproducibility": 0.0050222957,
            "Total Guage R&R": 0.0170851086,
            "Total variation": 0.0176988897
        },
        "Contribution": {
            "Part-to-part": 3.4679071962,
            "Opperator": 28.3763318533,
            "Repeat": 68.1557609505,
            "PartOperator": 0,
            "Reproducibility": 28.3763318533,
            "Total Guage R&R": 96.5320928038,
            "Total variation": 100
        },
        "Standard Deviation": {
            "Part-to-part": 0.0247746053,
            "Opperator": 0.070868157,
            "Repeat": 0.1098308379,
            "PartOperator": 0,
            "Reproducibility": 0.070868157,
            "Total Guage R&R": 0.1307100174,
            "Total variation": 0.1330371742
        },
        "Study Variation": {
            "Part-to-part": 18.6223177831,
            "Opperator": 53.2694395065,
            "Repeat": 82.5565024396,
            "PartOperator": 0,
            "Reproducibility": 53.2694395065,
            "Total Guage R&R": 98.2507469711,
            "Total variation": 100
        },
        "Tolerance": {
            "Part-to-part": 18.6223177831,
            "Opperator": 53.2694395065,
            "Repeat": 82.5565024396,
            "PartOperator": 0,
            "Reproducibility": 53.2694395065,
            "Total Guage R&R": 98.2507469711,
            "Total variation": 100
        }
    })
    //let data = csvData.map((data, index) => (data[variableNo]));
    //data = data.filter(value => value !== '' && !isNaN(parseFloat(value))).map(value => parseFloat(value))

    let data = csvData.map((data, index) => ([data[1], data[2], data[variableNo]]));
    data = data.filter(value => (value[variableNo - 1] !== '' && !isNaN(parseFloat(value[variableNo - 1]))))
    data = data.map(subArray => { const thirdElement = parseFloat(subArray[2]); return [subArray[0], subArray[1], thirdElement]; })
    data = data.filter(subArray => !isNaN(subArray[2]));

    const [actualData, setActualData] = useState(data);
    const [LSL, setLSL] = useState(1);
    const [USL, setUSL] = useState(2);
    const [k, setK] = useState(4);

    const updateCSVData = (event) => {
        updateVariableNo(event.ColNo)
        console.log("eventColNo", event.ColNo)
        //setVariableNo(event.ColNo);
        setCsvData(event.data)
        setClickedButton(event.ColNo);
    }

    const updateCSVHeader = (event) => {
        console.log(headers);
        let headers2 = [...headers];
        setHeaders(event.Headers)
        console.log("Updating headers: ", headers2, headers)
    }

    useEffect(() => {
        let data = csvData.map((data, index) => ([data[1], data[2], data[variableNo]]));
        data = data.filter(value => (value[variableNo - 1] !== '' && !isNaN(parseFloat(value[variableNo - 1]))))
        data = data.map(subArray => { const thirdElement = parseFloat(subArray[2]); return [subArray[0], subArray[1], thirdElement]; })
        data = data.filter(subArray => !isNaN(subArray[2]));
        setActualData(data);
    }, [csvData])

    useEffect(() => {
        console.log('actualData', actualData)
        makeCalculations()
    }, [actualData, groupBy, linesBy, k, LSL, USL])


    window.onafterprint = function () {
        let distributionPlot_Container = document.getElementById('distributionPlot_Container');
        distributionPlot_Container.classList.remove("col-xxl-6", "col-xl-6", "col-md-6", "col-sm-12", "col-12");
        distributionPlot_Container.classList.add("col-xxl-4", "col-xl-4", "col-md-4", "col-sm-12", "col-12");

        var distributionPlot = window.document.getElementById("distributionPlot");
        while (distributionPlot.children.length > 0) {
            distributionPlot.removeChild(distributionPlot.firstChild);
        }
        distributionPlot.style.width = '100%'
        window.Bokeh.embed.embed_item(pyPlot, "distributionPlot")

        let headerObj = document.getElementById('headerwrap')
        if(headerObj){
            headerObj.style.display = "block";
        }
        let footerObj = document.getElementById('footerwrap')
        if(footerObj){
            footerObj.style.display = "block";
        }
    };

    useEffect(() => {
        document.addEventListener('updateCSVData', updateCSVData);
        return () => { document.removeEventListener('updateCSVData', updateCSVData); };
    }, [])

    useEffect(() => {
        document.addEventListener('updateCSVHeader', updateCSVHeader);
        return () => { document.removeEventListener('updateCSVHeader', updateCSVHeader); };
    }, [])

    const handleFileChange = (file) => {
        Papa.parse(file, {
            complete: (result) => {
                const [header, ...csvData] = result.data; // Extract the first row as header
                for (let i = header.length; i < 10; i++) {
                    header.push("")
                }
                setHeaders(['', ...header]); // Set the headers to the state
                var newRowsList = [];
                var rowno = 1;
                csvData.forEach((row) => {
                    var cols = [rowno]
                    rowno += 1;
                    row.forEach((col) => {
                        if (!(col instanceof Array) && (col !== "")) {
                            cols.push(col)
                        }
                    })
                    let preColsLength = cols.length;
                    for (let i = cols.length; i <= 10; i++) {
                        cols.push("")
                    }
                    if (preColsLength > 1) {
                        newRowsList.push(cols)
                    }
                })
                for (let i = header.length; i <= 10; i++) {
                    header.push("")
                }
                setCsvData(newRowsList);
                updateVariableNo(3)
                //setVariableNo(1);
            },
        });
    };


    const printIt = async () => {
        document.getElementById('tablePlots').style.width = '100%';

        let distributionPlot_Container = document.getElementById('distributionPlot_Container');
        distributionPlot_Container.classList.remove("col-xxl-4", "col-xl-4", "col-md-4", "col-sm-12", "col-12");
        distributionPlot_Container.classList.add("col-xxl-6", "col-xl-6", "col-md-6", "col-sm-12", "col-12");
        //let qqPlot_Container = document.getElementById('qqPlot_Container');
        //qqPlot_Container.classList.remove("col-xxl-4", "col-xl-4", "col-md-4", "col-sm-12", "col-12");
        //qqPlot_Container.classList.add("col-xxl-6", "col-xl-6", "col-md-6", "col-sm-12", "col-12");

        var distributionPlot = window.document.getElementById("distributionPlot");
        while (distributionPlot.children.length > 0) {
            distributionPlot.removeChild(distributionPlot.firstChild);
        }
        distributionPlot.style.width = '50%'
        window.Bokeh.embed.embed_item(pyPlot, "distributionPlot")

        let headerObj = document.getElementById('headerwrap')
        if(headerObj){
            headerObj.style.display = "none";
        }
        let footerObj = document.getElementById('footerwrap')
        if(footerObj){
            footerObj.style.display = "none";
        }
        //distributionPlot = window.document.getElementById("qqPlot");
        //while (distributionPlot.children.length > 0) {
        //    distributionPlot.removeChild(distributionPlot.firstChild);
        //}
        //distributionPlot.style.width = '50%'
        //window.Bokeh.embed.embed_item(QQPlot, "qqPlot")

        setTimeout(() => {
            window.print();
        }, 100);

        return true;
    }

    const clearData = (option) => {
        if (option === 'reset') {
            setHeaders(emptyHeaders);
            setCsvData(emptyData);
            const eventResetData = new Event('resetData');
            document.dispatchEvent(eventResetData);
        }
        else {
            setHeaders(defaultHeaders);
            setCsvData(defaultData);
            updateVariableNo(3)
        }
    }

    function updateVariableNo(varNo) {
        console.log('varNo', varNo);
        //let data = csvData.map((data, index) => (data[varNo]));
        //data = data.filter(value => value !== '' && !isNaN(parseFloat(value))).map(value => parseFloat(value))

        let data = csvData.map((data, index) => ([data[1], data[2], data[varNo]]));
        data = data.filter(value => (value[varNo - 1] !== '' && !isNaN(parseFloat(value[varNo - 1]))))
        data = data.map(subArray => { const thirdElement = parseFloat(subArray[2]); return [subArray[0], subArray[1], thirdElement]; })
        data = data.filter(subArray => !isNaN(subArray[2]));

        setActualData(data);
        setVariableNo(varNo);
        setClickedButton(varNo);
    }

    const makeCalculations = async () => {
        var distributionPlot = document.getElementById("distributionPlot");
        console.log(LSL, USL, k);
        if (isNaN(LSL) || isNaN(USL) || isNaN(k)) {
            return 0;
        }
        if(actualData.length < 1){
            alert("No data selected");
            return 0;
        }
        //var qqPlot = document.getElementById("qqPlot");
        distributionPlot.innerHTML = "Loading Chart ...";
        //qqPlot.innerHTML = "Loading Chart ...";
        const url = 'https://django.qm-datalab.com/MSAType2';
        const params = {
            data: actualData,
            lsl: LSL,
            usl: USL,
            k: k,
            groupBy: groupBy,
            linesBy: linesBy,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height
        };
        //console.log("Fetching data from django view. ", params)
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        })
            .then(response => response.json())
            .then(data => {
                console.log("dataJSON", data)
                setPyPlot(data['pyplot'])
                setAnovaTable(data['TF-ANOVA'])
                setTable2(data['Table2'])
                var distributionPlot = document.getElementById("distributionPlot");
                distributionPlot.innerHTML = "";
                while (distributionPlot.children.length > 0) {
                    distributionPlot.removeChild(distributionPlot.firstChild);
                }
                window.Bokeh.embed.embed_item(data['pyplot'], "distributionPlot")

            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handleBlur = () => {
        makeCalculations()
    }

    const handleInputChange = (event) => {
        let id = event.target.id;
        let value = event.target.value;
        if (id !== "distribution") {
            if (value.indexOf(".") > -1) {
                value = parseFloat(value)
            }
            else {
                value = parseInt(value)
            }
        }
        switch (id) {
            case 'LSL':
                setLSL(value);
                break;
            case 'USL':
                setUSL(value);
                break;
            case 'k':
                setK(value);
                break
            default:
                console.log(id);
        }
        handleBlur()
    };
    const radios = [
        { name: 'Bauteil', value: 'Bauteil' },
        { name: 'Prüfer', value: 'Prüfer' }
    ];

    const radios2 = [
        { name: 'Prüfer', value: 'Prüfer' },
        { name: 'Bauteil', value: 'Bauteil' }
    ];

    const [clickedButton, setClickedButton] = useState(null);
    return (
        <>
            {

            }
            <Container id="docHeader" className='noprint'>
                <Row >
                    <Col className='headingText'>
                        Dateninput
                    </Col>
                </Row>
                <Row>
                    <Col className='text-start' xs={12} sm={12} md={6} xl={6} xxl={6}>
                        <FileInput onFileChange={handleFileChange} />
                    </Col>
                    <Col className='text-start' xs={6} sm={6} md={3} xl={3} xxl={3} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <Button variant="light" size='medium' className='links' onClick={() => clearData("reset")}>Alle Daten löschen</Button>
                    </Col>
                    <Col className='text-start' xs={6} sm={6} md={3} xl={3} xxl={3} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <Button variant="light" size='medium' className='links' onClick={() => clearData("default")}>Beispieldaten laden</Button>
                    </Col>
                </Row>
            </Container>
            <Container id='MSATable' className='noprint'>
                <Row>
                    <Col>
                        <MSATable data={Array.from(csvData)} headers={[...headers]} />
                    </Col>
                </Row>
            </Container>
            <Container className='mx-auto noprint' id='variablen'>
                <Row>
                    <Col sm='auto' className='text-start headingText' style={{ paddingTop: '10px', paddingBottom: '5px' }} id='variablen'>
                        Variablen
                    </Col>
                </Row>
                <Row>
                    <Col className='text-start ml-5 mr-5' style={{ paddingTop: '3px', paddingBottom: '3px', paddingLeft: '5px', paddingRight: '5px' }}>
                        {headers.map((header, index) => { if ((header !== "Bauteil") & (header !== "Prüfer") & (header !== "")) { return (<Button key={index} size='sm' className={`headerLinks ${clickedButton === index ? 'clicked' : ''}`} onClick={() => { setClickedButton(index); updateVariableNo(index); }}>{header}</Button>) } })}
                    </Col>
                </Row>
                <hr style={{ borderTop: '3px solid gray' }} className='my-1' />
            </Container>
            <Container id="tablePlots" className='my-3' style={{ textAlign: 'center', margin: 'auto' }}>
                <Row>
                    <Col >
                        <Row>
                            <Col className='text-right'>
                                Bauteil&nbsp;&nbsp;
                                <ButtonGroup className="mb-2">
                                    {radios.map((radio, idx) => (
                                        <ToggleButton
                                            size='sm'
                                            key={idx}
                                            id={`radioGroupBy-${idx}`}
                                            type="radio"
                                            variant="primary"
                                            name="radioGroupBy"
                                            value={radio.value}
                                            checked={groupBy === radio.value}
                                            onChange={(e) => setGroupBy(e.currentTarget.value)}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                            <Col className='text-left'>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                Prüfer&nbsp;&nbsp;
                                <ButtonGroup className="mb-2">
                                    {radios2.map((radio1, idx1) => (
                                        <ToggleButton
                                            size='sm'
                                            key={`radioLinesBy-${idx1}`}
                                            id={`radioLinesBy-${idx1}`}
                                            type="radio"
                                            variant="primary"
                                            name="radioLinesBy"
                                            value={radio1.value}
                                            checked={linesBy === radio1.value}
                                            onChange={(e) => setLinesBy(e.currentTarget.value)}
                                        >
                                            {radio1.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='justify-content-center'>
                    <Col xs={12} sm={12} md={6} xl={6} xxl={6} id='distributionPlot_Container' style={{ padding: 0, margin: 0 }}>
                        <div id='distributionPlot'></div>
                    </Col>
                </Row>
            </Container>
            <Container className='printable my-2' id="einstellungen">
                <hr style={{ borderTop: '3px solid gray' }} className='my-2' />
                <Row >
                    <Col sm='auto' className='text-start headingText'>
                        Einstellungen
                    </Col>
                </Row>
                <Row className='justify-content-center'>
                    <Col xs={12} sm={12} md={12} xl={12} xxl={12} className='text-start justify-content-center' style={{ border: '0px solid gray', fontSize: '1rem', paddingTop: 10, paddingBottom: 10 }}>
                        <Row>
                            <Col xs={4} sm={4} md={4} xl={4} xxl={4}>LSL<input id='LSL' type="number" class="form-control form-control-sm" defaultValue={LSL} placeholder="" onChange={handleInputChange} /></Col>
                            <Col xs={4} sm={4} md={4} xl={4} xxl={4}>USL<input id='USL' type="number" class="form-control form-control-sm" defaultValue={USL} placeholder="" onChange={handleInputChange} /></Col>
                            <Col xs={4} sm={4} md={4} xl={4} xxl={4}>k<input id='k' type="number" class="form-control form-control-sm" defaultValue={k} placeholder="" onChange={handleInputChange} /></Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <Container style={{ overflowX: 'auto' }}>
                <Row>
                    <Col xs={12} sm={12} md={8} xl={8} xxl={8} className='text-left' style={{ whiteSpace: 'nowrap', fontWeight: 'bold', backgroundColor: 'black', color: 'white' }}>
                        Zweifaktorielle ANOVA ohne Interaktion
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={8} xl={8} xxl={8} style={{ padding: 0 }}>
                        <Table striped bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th className='text-left'>Quelle</th>
                                    <th>DF</th>
                                    <th>SS</th>
                                    <th>MS</th>
                                    <th>F</th>
                                    <th>P</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-left'>Bauteil</td>
                                    <td>{anovaTable['df']['C(Bauteil)']}</td>
                                    <td>{anovaTable['sum_sq'].hasOwnProperty('C(Bauteil)') ? anovaTable['sum_sq']['C(Bauteil)'].toFixed(5) : ''}</td>
                                    <td>{anovaTable['mean_sq']['C(Bauteil)'].toFixed(5)}</td>
                                    <td>{anovaTable['F']['C(Bauteil)'].toFixed(5)}</td>
                                    <td>{anovaTable['PR(>F)']['C(Bauteil)'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Prüfer</td>
                                    <td>{anovaTable['df']['C(Prüfer)']}</td>
                                    <td>{anovaTable['sum_sq']['C(Prüfer)'].toFixed(5)}</td>
                                    <td>{anovaTable['mean_sq']['C(Prüfer)'].toFixed(5)}</td>
                                    <td>{anovaTable['F']['C(Prüfer)'].toFixed(5)}</td>
                                    <td>{anovaTable['PR(>F)']['C(Prüfer)'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Wiederholbarkeit</td>
                                    <td>{anovaTable['df']['Residual']}</td>
                                    <td>{anovaTable['sum_sq'].hasOwnProperty('Residual') ? anovaTable['sum_sq']['Residual'].toFixed(5) : ''}</td>
                                    <td>{anovaTable['mean_sq'].hasOwnProperty('Residual') ? anovaTable['mean_sq']['Residual'].toFixed(5) : ''}</td>
                                    <td>{anovaTable['F']['Residual']}</td>
                                    <td>{anovaTable['PR(>F)']['Residual']}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Gesamt</td>
                                    <td>{parseInt(anovaTable['df']['C(Bauteil)']) + parseInt(anovaTable['df']['C(Prüfer)']) + parseInt(anovaTable['df']['Residual'])}</td>
                                    <td>{(parseFloat(anovaTable['sum_sq']['C(Bauteil)']) + parseFloat(anovaTable['sum_sq']['C(Prüfer)']) + parseFloat(anovaTable['sum_sq']['Residual'])).toFixed(5)}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
            <Container style={{ overflowX: 'auto' }}>
                <Row>
                    <Col xs={12} sm={12} md={6} xl={6} xxl={6} className='text-left' style={{ whiteSpace: 'nowrap', fontWeight: 'bold', backgroundColor: 'black', color: 'white' }}>
                        Varianzkomponenten
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={6} xl={6} xxl={6} style={{ padding: 0 }}>
                        <Table striped bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th className='text-left'>Quelle</th>
                                    <th>VarKomp</th>
                                    <th>% Beitrag</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-left'>R&R ( Gesamt )</td>
                                    <td>{Table2['Variance (VarComp)']['Total Guage R&R'].toFixed(5)}</td>
                                    <td>{Table2['Contribution']['Total Guage R&R'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Wiederholbarkeit</td>
                                    <td>{Table2['Variance (VarComp)']['Repeat'].toFixed(5)}</td>
                                    <td>{Table2['Contribution']['Repeat'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Reproduzierbarkeit</td>
                                    <td>{Table2['Variance (VarComp)']['Reproducibility'].toFixed(5)}</td>
                                    <td>{Table2['Contribution']['Reproducibility'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Zwischen den Teilen
                                    </td>
                                    <td>{Table2['Variance (VarComp)']['Part-to-part'].toFixed(5)}</td>
                                    <td>{Table2['Contribution']['Part-to-part'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Gesamtstreuung</td>
                                    <td>{Table2['Variance (VarComp)']['Total variation'].toFixed(5)}</td>
                                    <td>{Table2['Contribution']['Total variation'].toFixed(5)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
            <Container style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <Row>
                    <Col xs={12} sm={12} md={8} xl={8} xxl={8} className='text-left' style={{ whiteSpace: 'nowrap', fontWeight: 'bold', backgroundColor: 'black', color: 'white' }}>
                        Beurteilung Messprozess
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={8} xl={8} xxl={8} style={{ padding: 0 }}>
                        <Table striped bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th className='text-left'>Quelle</th>
                                    <th>StdAbw</th>
                                    <th>Streu. in Unters. ({k} x SA)</th>
                                    <th>% Streu. in Unters.</th>
                                    <th>(SU/Tol%) Toleranz</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-left'>R&R ( Gesamt )</td>
                                    <td>{Table2['Standard Deviation']['Total Guage R&R'].toFixed(5)}</td>
                                    <td>{(Table2['Standard Deviation']['Total Guage R&R'] * k).toFixed(5)}</td>
                                    <td>{Table2['Study Variation']['Total Guage R&R'].toFixed(5)}</td>
                                    <td>{Table2['Tolerance']['Total Guage R&R'] === 'Infinity' ? 'Infinity' : Table2['Tolerance']['Total Guage R&R'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Wiederholbarkeit</td>
                                    <td>{Table2['Standard Deviation']['Repeat'].toFixed(5)}</td>
                                    <td>{(Table2['Standard Deviation']['Repeat'] * k).toFixed(5)}</td>
                                    <td>{Table2['Study Variation']['Repeat'].toFixed(5)}</td>
                                    <td>{Table2['Tolerance']['Repeat'] === 'Infinity' ? 'Infinity' : Table2['Tolerance']['Repeat'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Reproduzierbarkeit</td>
                                    <td>{Table2['Standard Deviation']['Reproducibility'].toFixed(5)}</td>
                                    <td>{(Table2['Standard Deviation']['Reproducibility'] * k).toFixed(5)}</td>
                                    <td>{Table2['Study Variation']['Reproducibility'].toFixed(5)}</td>
                                    <td>{Table2['Tolerance']['Reproducibility'] === 'Infinity' ? 'Infinity' : Table2['Tolerance']['Reproducibility'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Zwischen den Teilen</td>
                                    <td>{Table2['Standard Deviation']['Part-to-part'].toFixed(5)}</td>
                                    <td>{(Table2['Standard Deviation']['Part-to-part'] * k).toFixed(5)}</td>
                                    <td>{Table2['Study Variation']['Part-to-part'].toFixed(5)}</td>
                                    <td>{Table2['Tolerance']['Part-to-part'] === 'Infinity' ? 'Infinity' : Table2['Tolerance']['Part-to-part'].toFixed(5)}</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>Gesamtstreuung</td>
                                    <td>{Table2['Standard Deviation']['Total variation'].toFixed(5)}</td>
                                    <td>{(Table2['Standard Deviation']['Total variation'] * k).toFixed(5)}</td>
                                    <td>{Table2['Study Variation']['Total variation'].toFixed(5)}</td>
                                    <td>{Table2['Tolerance']['Total variation'] === 'Infinity' ? 'Infinity' : Table2['Tolerance']['Total variation'].toFixed(5)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
            <Container className='my-5 text-left noprint' id='paragraphs' >
                <hr style={{ borderTop: '3px solid gray' }} className='my-4' />
                <Row>
                    <Col>
                        <h1 className="headingText">
                            Messsystem Analyse Verfahren 2 online und kostenlos mit dem Analyse Tool von QM-Datalab
                        </h1>
                        <p>
                            Analysiere unkompliziert und kostenlos online deine Messdaten. Füge einfach deine Daten in das QM-Datalab Tool ein, wähle aus welche Daten du auswerten möchtest und QM-Datalab erstellt dir alle benötigten Analysen, Kennwerte und Diagramme.
                        </p>
                        <h2 className="subHeadingText my-2">
                            Die großen Vorteile von QM-Datalab
                        </h2>
                        <ul className="list-disc pl-16 my-3">
                            <li>Von QM-Manager f&uuml;r QM-Manager: Genau die Analysen, die du brauchst</li>
                            <li>100% Datensicherheit: Die Analysen werden nur auf deinem Ger&auml;t im Browser durchgef&uuml;hrt, es werden keinerlei Daten an Server gesendet</li>
                            <li>Einzigartige Nutzerfreundlichkeit: Alle Analysen auf Knopfdruck</li>
                            <li>Kein Installations- und Wartungsaufwand: Direkt im Browser</li>
                        </ul>
                        <h2 className="headingText" style={{ wordWrap: 'break-word' }}>
                            Messsystem Analyse Type 2: Nutzen, Berechnung und Bewertung der Wiederholbarkeit und Reproduzierbarkeit (Gage R&R)
                        </h2>
                        <h1 className='subHeadingText my-3'>Einleitung</h1>
                        <p className='my-2'>
                            Die Messsystem Analyse Type 2, auch als MSA Type 2 bekannt, ist eine wichtige Methode zur Bewertung der Zuverlässigkeit und Konsistenz von Messsystemen. Durch die Analyse der Wiederholbarkeit und Reproduzierbarkeit ermöglicht sie eine fundierte Beurteilung der Messgenauigkeit und -präzision. In diesem Artikel werden wir den Nutzen der Messsystem Analyse Type 2 erläutern und einen Einblick in die Berechnung und Bewertung der Wiederholbarkeit und Reproduzierbarkeit geben. Dabei werden typische Kennzahlen zur Bewertung des Messsystems wie Repeatability und Reproducibility betrachtet.
                        </p>
                        <h1 className='subHeadingText my-3'>Nutzen der Messsystem Analyse Type 2</h1>
                        <p className='my-2'>
                            Die Messsystem Analyse Type 2 spielt eine entscheidende Rolle bei der Bewertung und Optimierung von Messprozessen. Ihre Vorteile sind vielfältig und umfassen unter anderem:
                        </p>
                        <ul className="list-disc pl-16">
                            <li><b>Qualitätsverbesserung:</b> Durch die Identifizierung von Messsystemfehlern und die anschließende Optimierung können die Qualität und Präzision von Messungen erhöht werden.</li>
                            <li><b>Kostenreduktion:</b> Ein optimiertes Messsystem reduziert Ausschuss und Nacharbeit, was zu erheblichen Kosteneinsparungen führen kann.</li>
                            <li><b>Entscheidungsgrundlage:</b> Eine genaue Bewertung der Wiederholbarkeit und Reproduzierbarkeit liefert eine verlässliche Grundlage für fundierte Entscheidungen im Qualitätsmanagement.</li>
                            <li><b>Kundenvertrauen:</b> Zuverlässige Messergebnisse erhöhen das Vertrauen der Kunden in die Produkte und Dienstleistungen eines Unternehmens.</li>
                            <li><b>Abschnitt 2:</b> Berechnung der Wiederholbarkeit und Reproduzierbarkeit (ca. 300 Wörter):
                                <p>
                                    Die Berechnung der Wiederholbarkeit und Reproduzierbarkeit ist ein zentraler Aspekt der Messsystem Analyse Type 2. Die Wiederholbarkeit, auch als Repeatability bezeichnet, beschreibt die Fähigkeit des Messsystems, bei wiederholten Messungen unter gleichen Bedingungen ähnliche Ergebnisse zu erzielen. Die Reproduzierbarkeit, auch als Reproducibility bezeichnet, bewertet hingegen die Variation der Messergebnisse bei Messungen durch verschiedene Bediener oder in unterschiedlichen Umgebungen.
                                </p>
                            </li>
                        </ul>
                        <p className='my-3'>
                            Die Berechnung der Wiederholbarkeit und Reproduzierbarkeit erfolgt üblicherweise mithilfe einer sogenannten Gage R&R-Analyse (Gage Repeatability and Reproducibility). Dabei werden mehrere Messungen desselben Prüflings durchgeführt, durch verschiedene Prüfer. Anschließend werden die Variationen innerhalb und zwischen den Messungen analysiert. Typischerweise wird der Anteil der Variationen der Wiederholbarkeit und Reproduzierbarkeit am Gesamtmessfehler betrachtet, um die Messsystemfähigkeit zu bewerten.
                        </p>
                        <h1 className='subHeadingText my-3'>Wiederholbarkeit und Reproduzierbarkeit</h1>
                        <p>
                            Die Wiederholbarkeit und Reproduzierbarkeit spielen eine zentrale Rolle bei der Bewertung der Messsystemleistung in der Messsystem Analyse Type 2. Die Wiederholbarkeit, auch bekannt als Repeatability, beschreibt die Fähigkeit des Messsystems, bei wiederholten Messungen unter gleichen Bedingungen ähnliche Ergebnisse zu erzielen. Sie bezieht sich auf die Variation der Messwerte, die durch denselben Bediener und mit derselben Ausrüstung erzeugt werden. Eine hohe Wiederholbarkeit deutet darauf hin, dass das Messsystem konsistente und zuverlässige Ergebnisse liefert.
                        </p>
                        <p>
                            Die Reproduzierbarkeit, auch bekannt als Reproducibility, hingegen bezieht sich auf die Variation der Messwerte, die durch verschiedene Bediener erzeugt werden. Eine gute Reproduzierbarkeit bedeutet, dass das Messsystem unabhängig vom Bediener ähnliche Messergebnisse liefert.
                        </p>
                        <h1 className='subHeadingText my-3'>Typische Kennzahlen zur Bewertung des Messsystems</h1>
                        <p>Bei der Bewertung der Wiederholbarkeit und Reproduzierbarkeit werden verschiedene Kennzahlen verwendet, um die Leistung des Messsystems zu quantifizieren. Dazu gehören unter anderem:</p>
                        <ul className='list-disc pl-16'>
                            <li>
                                <b>Gage R&R-Komponenten:</b> Die Variationen des Messsystems werden in verschiedene Komponenten unterteilt, wie beispielsweise die Variation aufgrund von Wiederholbarkeit, Reproduzierbarkeit und Teile-zu-Teile-Variation.
                            </li>
                            <li><b>Prozentuale Beitrag der Variationen:</b> Die prozentualen Beiträge der Wiederholbarkeit und Reproduzierbarkeit am Gesamtmessfehler werden berechnet, um die relative Bedeutung der einzelnen Komponenten zu bewerten.</li>
                            <li><b>Gage R&R-Studien:</b> Mithilfe von Gage R&R-Studien können spezifische Kennzahlen wie der Gage R&R-Wert, die Toleranzabdeckung und der Prozessfähigkeitsindex berechnet werden. Diese Kennzahlen bieten eine umfassende Bewertung der Messsystemleistung.</li>
                        </ul>
                        <h1 className='subHeadingText my-3'>Fazit</h1>
                        <p>Die Messsystem Analyse Type 2, insbesondere die Bewertung der Wiederholbarkeit und Reproduzierbarkeit, ist von großer Bedeutung für Unternehmen, die qualitativ hochwertige Messungen und Prozesse gewährleisten möchten. Durch die Berechnung und Bewertung typischer Kennzahlen wie Repeatability, Reproducibility und anderen Gage R&R-Komponenten können Schwachstellen identifiziert und Maßnahmen zur Verbesserung ergriffen werden. Eine fundierte Messsystem Analyse Type 2 bietet Unternehmen die Möglichkeit, die Qualität zu steigern, Kosten zu senken und das Vertrauen der Kunden zu stärken.</p>
                    </Col>
                </Row >
            </Container >
        </>
    );
}
export default MSAType2;